export default function PHP_Intro() {
  return (
    <div>
      <h1>PHP_Intro</h1>
    </div>
  );
}
